// Evidence Collection Recommendation Page Translation
export default {
  // Page Title
  title: "Evidence Recommendation",

  // Button Text
  buttons: {
    uploadEvidence: "Upload Evidence",
    reset: "Reset",
    query: "Query",
    generateDocument: "Generate Document",
    cancel: "Cancel",
    upload: "Upload",
    confirm: "Confirm",
    downloadTemplate: "Download Template",
  },

  // Navigation Links
  navigation: {
    illustration: "Evidence Instructions",
    platform: "Evidence Platform",
    flowPath: "Evidence Process",
  },

  // Dialog Titles
  dialog: {
    illustration: "Evidence Instructions",
    platform: "Evidence Platform",
    flowPath: "Evidence Process",
    uploadEvidence: "Upload Evidence",
    downloadTemplate: "Select Template to Download",
    contactService: "Contact Service",
  },

  // Suggestion List Page (suggestion.vue)
  suggestion: {
    // Search Placeholders
    placeholders: {
      content: "Enter evidence content",
      platform: "Select evidence platform",
      priority: "Select evidence priority",
      status: "Select evidence status",
      caseName: "Enter case name",
      userId: "Enter evidence user ID",
      userName: "Enter evidence user name",
    },

    // Table
    table: {
      loading: "Loading...",
      totalPrefix: "Total",
      totalSuffix: "records",
      columns: {
        content: "Evidence Content",
        platform: "Platform",
        priority: "Priority",
        status: "Status",
        relatedCase: "Related Case",
        reason: "Evidence Reason",
        creator: "Creator",
        userId: "Evidence User ID",
        userName: "Evidence User Name",
        createTime: "Create Time",
        operation: "Operation",
      },
      actions: {
        delete: "Delete",
      },
    },

    // Messages
    messages: {
      platformWarning:
        "Currently only supports batch selection of evidence content from the same platform",
      deleteConfirm: "This will permanently delete this data, are you sure?",
      deleteTitle: "Notice",
      deleteSuccess: "Deleted successfully!",
      deleteCancelled: "Deletion cancelled",
      confirmButton: "Confirm",
      cancelButton: "Cancel",
    },
  },

  // Upload Dialog (uploadDialog.vue)
  upload: {
    // Instruction Title
    instructionTitle: "Evidence Upload Instructions",

    // Instructions
    instructions: {
      line1:
        "1. Currently supported platforms include Binance, Huobi, Huobi-HTX, KuCoin, Okx, Mexc, Bitget, Bitpie, imToken, TokenPocket, BitgetWallet and other mainstream exchanges and wallet platforms.",
      line2:
        "2. For other exchange files, you can upload them to the platform. The platform will develop file parsing for that exchange later. If you need to parse the evidence file now, please contact us.",
    },

    // Form
    form: {
      platform: "Platform",
      platformPlaceholder: "Please select (required)",
      relatedCase: "Related Case (optional)",
      casePlaceholder: "Select existing case",
      uploadFile: "Upload Evidence File",
      note: "Note: Current version only supports parsing xlsx format files. For csv format files, please convert to xls or xlsx format before uploading.",
    },

    // Contact Service
    contact: {
      instruction: "To contact customer service, scan the QR code below.",
      wechat: "WeChat",
    },

    // Upload Success
    success: {
      title: "Evidence file uploaded successfully",
      message:
        "The system is parsing, please wait. Refresh the page later to view the parsing results.",
    },
  },

  // Dialog Content (dialogText.vue)
  dialogContent: {
    // Illustration
    illustration: {
      p1: "1. Blockchain addresses are anonymous, making it impossible to directly know the identity of the actual controller. After verifying and analyzing the addresses involved and obtaining exchange clues, you can conduct evidence collection from the exchange platform to obtain identity information and transaction behavior data of the people behind the clues.",
      p2: "2. In the case canvas, you can add exchange clue data to evidence recommendations with one click, then select the content that needs evidence collection to generate evidence documents with one click. Follow the evidence collection guide to ensure judicial evidence collection 'stays on track'.",
      p3: "3. Supports uploading and parsing evidence files from multiple mainstream exchanges and wallet companies. Graphical presentation of complex original table content makes evidence analysis 'not cumbersome'.",
      p4: "4. Use person analysis ID to directly expand analysis in the case canvas, flexibly display person transfer relationships, making person judgment 'not difficult'.",
    },

    // Platform
    platform: {
      email: "Evidence Email:",
      subject: "Suggested Email Subject:",
      attachments: "Email Attachments:",
      notes: "Other Notes:",
      noData: "None",
      noteItems: {
        note1:
          "1. Decentralized wallet service providers cannot freeze user assets",
        note2:
          "2. The data and time range of evidence collection should be as clear as possible, it is recommended to retrieve all information and operation records within the time period",
        note3:
          "3. It is recommended to clearly request that the data material format returned by the platform should be Excel, images and PDF formats are strictly prohibited",
        note4:
          "4. The platform needs to be required to affix the company's electronic seal for subsequent evidence preservation",
        note5:
          "5. For overseas exchanges, to improve the success rate of evidence collection, it is recommended to use government email addresses such as gov.cn to send evidence requests",
      },
    },

    // Flow Path
    flowPath: {
      step1: {
        title: "1. Evidence Recommendation List",
        content:
          "Added evidence data will be displayed on the evidence recommendation page according to conditions such as case and evidence platform. Users can view and perform quick operations on all detailed data of evidence recommendations on this page.",
      },
      step2: {
        title: "2. Generate Evidence Documents",
        content:
          "Select the case and platform that currently need evidence collection, click generate document to jump to the evidence data details of the current case, operate on the evidence data according to actual needs, and batch generate evidence documents after confirmation.",
      },
      step3: {
        title: "3. Download Evidence Document Template",
        content:
          "Download the evidence document template, improve the content according to the evidence document guide, and send it to the corresponding evidence platform.",
      },
      step4: {
        title: "4. Upload Evidence Files",
        content:
          "After receiving the evidence files returned by the platform, upload the evidence files to this system through upload evidence. The system will automatically parse the file content, and users can view the parsing progress in the evidence files.",
      },
      step5: {
        title: "5. Intelligent Evidence File Parsing",
        content:
          "After the evidence file data parsing is completed, the system will automatically synchronize the data. Users can use the person analysis ID directly in the canvas for expanded analysis. The hierarchical display method will help users conduct case judgment more efficiently, clearly and accurately.",
      },
    },
  },

  // Tips Dialog (Tips.vue)
  tips: {
    title: "Notice",
    content:
      "The current version does not support parsing this exchange file. You can upload the file to the platform, and the platform will develop file parsing for this exchange later. If you need to parse the evidence file now, please",
    contactUs: "contact us",
    messages: {
      uploadSuccess: "Original evidence file uploaded successfully",
      uploadError:
        "Upload failed, please refresh the page and try again, or check the network",
    },
  },

  // File Upload Component (newOssuplodefile.vue)
  ossUpload: {
    dragText: "Click or drag files here to upload",
    supportText: "Supported extensions: .xls .xlsx",
    uploaded: "Evidence file uploaded",
    uploading: "Uploading, please wait...",
    uploadComplete: "Upload completed",
    messages: {
      uploadError: "Upload failed, please try again later or check the network",
      uploadFailed: "Upload failed, please refresh the page and re-upload",
      uploadFailedRefresh:
        "Upload failed, please refresh the page and try again, or check the network",
      fileLimitWarning:
        "The limit is 20 files, you selected {current} files this time, total {total} files selected",
    },
  },

  // Document File Page (Documentfile.vue)
  documentFile: {
    title: "Evidence Document",
    downloadButton: "Download Evidence Document",
    preview: "Evidence Document Preview",
    methodDescription: "Evidence Method Description",
    loading: "Loading...",
    fileName: "Evidence Collection Notice",
    fields: {
      email: "Evidence Email:",
      emailTitle: "Suggested Email Subject:",
      attachments: "Email Attachment Materials:",
      notes: "Other Notes:",
      noData: "None",
    },
    notesList: {
      note1:
        "1. Decentralized wallet service providers' user assets cannot be frozen",
      note2:
        "2. The time range for evidence collection should be as clear as possible, it is recommended to collect all information and operation records",
      note3:
        "3. It is recommended to clearly request that the data materials returned from the platform be in Excel format, images and PDF formats are strictly prohibited",
      note4:
        "4. The platform needs to be required to affix the company's electronic official seal for subsequent evidence preservation",
      note5:
        "5. For overseas exchanges, to improve the success rate of evidence collection, it is recommended to use gov.cn and other government email addresses to send evidence requests",
    },
  },

  // Survey User List (querysuspectser.vue)
  surveyUserList: {
    title: "Survey Users",
    placeholders: {
      userId: "Enter User ID",
      name: "Enter Name",
      phone: "Enter Phone Number",
      email: "Enter Email",
      platform: "Select Survey Platform",
      idNumber: "Enter ID Number",
      age: "Enter Age",
      caseName: "Enter Case Name",
    },
    buttons: {
      reset: "Reset",
      query: "Query",
      relateCase: "Relate Case",
      view: "View",
      surveyReport: "Survey Report",
    },
    table: {
      total: "Total",
      dataUnit: "records",
      loading: "Loading...",
      columns: {
        userAnalysisId: "User Analysis ID",
        name: "Name",
        sex: "Gender",
        idNumber: "ID Number",
        homePlace: "Native Place",
        email: "Email",
        phone: "Phone",
        relatedCase: "Related Case",
        operation: "Operation",
      },
      sex: {
        unknown: "Unknown",
      },
    },
    messages: {
      caseUpdateSuccess: "Case updated successfully",
      copySuccess: "Copied successfully!",
    },
  },
  caseRelation: {
    title: "Related Case",
    info: {
      title: "User Case Association Description:",
      description:
        "You can associate investigation users with your cases. After association, the corresponding case will display the investigation user data for better data management and analysis.",
    },
    form: {
      caseLabel: "Related Case:",
      casePlaceholder: "Please select a related case",
    },
    validation: {
      caseRequired: "Please select a related case",
    },
    buttons: {
      reset: "Reset",
      submit: "Submit",
    },
  },

  // Survey Report (surveyReport.vue)
  surveyReport: {
    title: "Survey Report",
    buttons: {
      preview: "Generate Report",
      cancel: "Cancel",
    },
    loading: "Loading...",
    sections: {
      summary: "Survey Summary",
      personalInfo: "Personal Information",
      accountBalance: "Account Balance",
      otcTransaction: "OTC Transaction Overview",
      depositWithdrawal: "Deposit/Withdrawal Overview",
      blockchainDeposit: "Blockchain Deposit - Currency Summary",
      blockchainWithdraw: "Blockchain Withdrawal - Currency Summary",
      internalDeposit: "Internal Deposit - Currency Summary",
      internalWithdraw: "Internal Withdrawal - Currency Summary",
      keyAddress: "Key Transaction Address (Optional)",
      loginIp: "Login IP Statistics",
      usedAddress: "Used Addresses",
      userBehavior: "User Behavior",
    },
    table: {
      // Personal Info Table
      personalInfo: {
        name: "Name",
        sex: "Gender",
        nationality: "Nationality",
        phone: "Phone",
        idNumber: "ID Number",
        email: "Email",
        registerTime: "Registration Time",
      },
      // Balance Table
      balance: {
        currency: "Currency",
        balance: "Balance",
        usdtBalance: "USDT Equivalent",
        accountType: "Account Type",
        usdtAmount: "Balance (USDT)",
      },
      // OTC Table
      otc: {
        direction: "Direction",
        count: "Transaction Count",
        legalTender: "Fiat Type",
        totalAmount: "Total Amount",
        currency: "Currency",
        tradeAmount: "Trade Amount",
        buy: "Buy",
        sell: "Sell",
      },
      // Deposit/Withdrawal Table
      deposit: {
        currency: "Currency",
        depositCount: "Deposit Count",
        depositAmount: "Deposit Amount",
        withdrawCount: "Withdrawal Count",
        withdrawAmount: "Withdrawal Amount",
        usdtAmount: "USDT Equivalent",
        timeRange: "Time Range",
      },
      // Login IP Table
      loginIp: {
        ipAddress: "IP Address",
        location: "IP Location",
        loginCount: "Login Count",
        lastLoginTime: "Last Login Time",
      },
      // Address Table
      address: {
        blockchain: "Blockchain",
        address: "Address",
      },
      // User Behavior Table
      behavior: {
        action: "Transaction Action",
        direction: "Withdraw/Deposit",
        amount: "Amount",
        currency: "Currency",
        time: "Time",
        deposit: "Deposit",
        withdraw: "Withdraw",
      },
    },
    tips: {
      selectModule: "Select modules below",
      selectAll: "Select All",
      legalTenderSummary: "Fiat Summary",
      virtualCurrencySummary: "Crypto Summary",
      keyAddressPlaceholder: "Key transaction address (optional)",
      usedAddressCount: "Exchange addresses used by this account:",
      usedAddressTotal: "Total: {count}",
      recentBehaviorNote: "Showing only the last 20 operations",
      noData: "No Data",
      notInvolved: "This data is not covered by the current survey",
    },
    radioOptions: {
      all: "All",
      recentYear: "Recent Year",
      recent20: "Recent 20",
      commonAddress: "Common Addresses",
    },
  },

  // Survey File Preview (surveyFilePreview.vue)
  surveyFilePreview: {
    title: "AI Analysis Report",
    buttons: {
      assistance: "Appraisal Assistance",
      edit: "Edit",
      download: "Download Report",
      downloading: "Downloading",
      previousStep: "Previous",
    },
    loading: "Loading...",
    assistance: {
      publicAccount: "WeChat Official Account",
      customerService: "WeChat Customer Service",
      tip: "Scan QR code to follow official account or add customer service",
    },
  },
};
